<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="top_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit1">库尔科技</div>
					<div class="txt">为全球提供 实惠 易用 精准 的诊断产品</div>
					<div class="tit2">运用现代生物工程技术和医学研究成果，为全球人类健康事业服务!</div>
				</div>
				<img class="bg" src="../../../assets/img_public/about/qyjj/h5_block01.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="bot_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">CorDx集团</div>
					<div class="txt">
						北京库尔科技有限公司为美国CorDx Union集团旗下子公司。CorDx Union(简称CU)成立于2006年，是综合研发、生产、营销、服务为一体的国际化集团公司，设有Accu News准信、Coretests库尔科技、Abiores佳宝瑞源、Jtests建英佳、Bonore保诺塑业、Cupet夕友新能源等品牌系，共21家子公司。
					</div>
					<div class="txt">
						CU以医疗器械&诊断试剂为主业，产品销往170多个国家和地区，在全球拥有上1亿用户，广泛应用于临床检验、基层医疗、现场执法、疫情监控、灾难救援、家庭自测及健康管理等领域。
					</div>
					<div class="txt">
						CU全球拥有四个研究院，布局于加州SD，北京大兴，河北雄安，中国海南岛，持续提升分子诊断、胶体金层析、荧光免疫、生物芯片、重组蛋白、mRNA疫苗、宠物用品、电池材料、Ai质量管理系统等科技创新平台。诊疗产品主要用于传染病、肿瘤、心脑血管、炎症、药物滥用等病症。CU制造基地总面积3万平米，同时也为医药同行提供优质服务。
					</div>
					<div class="txt">
						CU以“安全有效 使命必达”为宗旨，秉承“从有机到安息 全供应链服务”的愿景，充分运用现代生物工程技术和医学研究成果，打造超一流医药企业，热心公益，为全球健康事业服务!
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_banner">
					<van-swipe
						class=""
						:loop="false"
						:autoplay="3000"
						indicator-color="white"
						:stop-propagation="false"
						:show-indicators="false"
						:width="185"
					>
						<van-swipe-item v-for="(value2, index2) in listData2" :key="index2"><!-- @click="showBigImg(value2.image)" -->
							<div class="block_main">
								<img class="img_el" lazy-load :src="value2.image" />
								<div class="tit">{{ value2.title }}</div>
								<div class="txt">{{ value2.text }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">产品销往170多个国家和地区，在全球拥有上亿用户</div>
				<img src="../../../assets/img_public/about/qyjj/h5_block03.webp" />
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_banner">
					<van-swipe
						class=""
						:loop="false"
						:autoplay="3000"
						indicator-color="white"
						:stop-propagation="false"
						:show-indicators="false"
						:width="230"
					>
						<van-swipe-item v-for="(value2, index2) in listData" :key="index2" @click="showBigImg(value2.image)">
							<div class="block_main">
								<img class="img_el" lazy-load :src="value2.image" />
								<div class="tit">{{ value2.title }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块4-->
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		//
	},
	data() {
		return {
			listData: [
				{ image: require('@/assets/img_public/about/qyjj/CJ_01.webp'), title: '工厂图' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_02.webp'), title: '实验室图' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_03.webp'), title: '科研图' }
			],
			listData2: [
				{ image: require('@/assets/img_public/about/qyjj/img_01.webp'), title: '全球化', text: 'Globalization' },
				{ image: require('@/assets/img_public/about/qyjj/img_02.webp'), title: '研发', text: 'Research and Development' },
				{ image: require('@/assets/img_public/about/qyjj/img_03.webp'), title: '实验', text: 'Experiment' },
				{ image: require('@/assets/img_public/about/qyjj/img_04.webp'), title: '销售', text: 'Retail sales' },
			]
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块4
	.block_4{
		padding: 40px 0 40px 20px;
		background-color: #F7F6F9;
		.block_banner{
			position: relative;
			.block_main{
				margin-right: 20px;
				.tit{
					padding-top: 20px;
					text-align: center;
					font-size: 18px;
				}
				.img_el{
					width: 100%;
					border-radius: 8px;
				}
			}
		}
	}
	//块3
	.block_3{
		img{
			width: 100%;
		}
		.tit{
			padding: 40px 20px 20px 20px;
			font-size: 18px;
		}
	}
	//块2
	.block_2{
		padding: 40px 0 0px 20px;
		.block_banner{
			position: relative;
			.block_main{
				position: relative;
				margin-right: 20px;
				.tit{
					position: absolute;
					bottom: 36px;
					width: 100%;
					text-align: center;
					color: #ffffff;
					font-size: 20px;
				}
				.txt{
					position: absolute;
					bottom: 20px;
					width: 100%;
					text-align: center;
					color: #ffffff;
					font-size: 12px;
				}
				.img_el{
					width: 100%;
					border-radius: 8px;
				}
			}
		}
	}
	//块1
	.block_1{
		.bot_box{
			padding: 40px 20px;
			border-bottom: 1px solid #E3E1E6;
			.txt{
				padding-bottom: 10px;
				line-height: 1.8;
			}
			.tit{
				padding-bottom: 24px;
				font-size: 24px;
				font-weight: bold;
				color: #A50073;
				text-align: center;
			}
		}
		img.bg{
			width: 100%;
		}
		.top_box{
			padding: 40px 20px;
			text-align: center;
			.tit2{
				font-size: 18px;
				font-weight: bold;
				color: #A50073;
			}
			.txt{
				padding: 10px 0 10px 0;
			}
			.tit1{
				font-size: 30px;
				font-weight: bold;
			}
		}
	}
}
</style>